<template>
  <div class="overflow-x-auto hide-scroll-bar flex items-center md:justify-center gap-4 p-4">
    <TsMedia v-for="items in data"
             append-class="w-max min-w-48 shadow-[0px_4px_13.7px_0px_#D4DAE1] rounded bg-white h-full justify-center items-center py-2.5 px-1.5">
      <TsMediaStart append-class="mr-3">
        <TsImage v-if="items && items.image" :src="items.image" :alt="items.alt || 'Free Delivery'" width="28" height="28" loading="lazy"/>
      </TsMediaStart>
      <TsMediaContent class="max-w-max">
        <TsTypography variant="sm" append-class="text-primary mb-0">
          {{ items.heading }}
        </TsTypography>
        <TsTypography v-if="items.description" variant="sm" append-class="text-primary mb-0 whitespace-nowrap">
          {{ items.description }}
        </TsTypography>
        <TsImage v-if="items && items.description_img" :src="items.description_img" :alt="items.heading" height="15" width="85" loading="lazy"/>
      </TsMediaContent>
    </TsMedia>
  </div>
</template>

<script setup lang="ts">


const TsMediaStart = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaStart.vue')
);


const TsMediaContent = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaContent.vue')
);

const high_five = [
  {
    image: '/images/logos/delivery-boy.svg',
    heading: '100+ Location',
    description: 'Click & Collect 10min',
  },
  {
    image: '/images/logos/delivery.svg',
    heading: 'Free Delivery',
    description: 'From €30',
  },
  {
    image: '/images/logos/deal.svg',
    heading: 'Everyday',
    description: 'Great Value',
  },
  {
    image: '/images/logos/pro.svg',
    heading: 'Pro Card',
    description: 'Save 5% Everyday',
  },
  {
    image: '/images/logos/excelent.svg',
    heading: 'Excellent TrustPilot',
    description_img: '/images/logos/ratings.png',
  }
]

type Props = {
  image?: string;
  alt?: string | number;
  heading?: string;
  description?: string;
  description_img?: string;
  dataTestid?: string;
  data?:any;
};

const props = withDefaults(defineProps<Props>(), {
  image: '/images/logos/delivery-boy.svg',
  heading: '100+ Location',
  data:[
    {
      image: '/images/logos/delivery-boy.svg',
      heading: '100+ Location',
      description: 'Click & Collect 10min',
    },
    {
      image: '/images/logos/delivery.svg',
      heading: 'Free Delivery',
      description: 'From €30',
    },
    {
      image: '/images/logos/deal.svg',
      heading: 'Everyday',
      description: 'Great Value',
    },
    {
      image: '/images/logos/pro.svg',
      heading: 'Pro Card',
      description: 'Save 5% Everyday',
    },
    {
      image: '/images/logos/excelent.svg',
      heading: 'Excellent TrustPilot',
      description_img: '/images/logos/ratings.png',
    }
  ]
});
</script>
